import gql from 'graphql-tag';

export default gql`
  query getUploadInfo($fileName: String!, $uploadType: UploadType!) {
    getUploadInfo(input: { fileName: $fileName, uploadType: $uploadType }) {
      uploadType
      uploadUrl
    }
  }
`;
